import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StackScreenProps } from "../../types";
import {
  View,
  Text,
  Heading,
  Pressable,
  ScrollView,
  Box,
  HStack,
  Flex,
} from "native-base";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Swiper from "react-native-web-swiper";

const slideItems = [
  {
    text: "Detailed soil survey and soil fertility mapping to enhance management of problematic soils. ",
    image: require("../../assets/vectors/survey.png"),
  },
  {
    text: "Dissemination of innovation and technologies for managing problematic soils in Nigeria.",
    image: require("../../assets/vectors/box.png"),
  },
  {
    text: "Evaluation of small-scale demonstration plots for promoting participatory evaluation of technologies and training of farmers on farmers’ fields.",
    image: require("../../assets/vectors/chart.png"),
  },
  {
    text: "Technology diffusion and sensitization of demonstration plots results for improved crop production and livelihood.",
    image: require("../../assets/vectors/plant.png"),
  },
  {
    text: "Sensitization of the private sector, financial institutions, and policymakers on the management of problematic soils.",
    image: require("../../assets/vectors/finance.png"),
  },
];

type RenderItemProps = { item: { text: string; image: any }[]; index: number };

const renderItem = ({ item, index }: RenderItemProps) => (
  <>
    {item?.map((itm) => (
      <Box
        bg="white"
        p={3}
        justifyContent="center"
        mb={5}
        borderWidth={4}
        borderColor="#ddd"
        borderRadius={15}
        key={itm.text}
      >
        <Image
          source={itm?.image}
          style={{
            width: 24,
            height: 28,
            alignSelf: "center",
            marginBottom: 10,
          }}
        />
        <Text color={"#009C4D"} textAlign="center">
          {itm?.text}
        </Text>
      </Box>
    ))}
  </>
);

const Agribooster = ({ navigation }: StackScreenProps<"CropResearch">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  type RenderItemProps = {
    item: any[];
    index: number;
  };
  const renderItem = ({ item, index }: RenderItemProps) => (
    <Box
      w={300}
      h={350}
      mb={5}
      rounded={"md"}
      margin="auto"
      key={index}
      alignSelf="center"
    >
      <ImageBackground
        source={item}
        resizeMode="cover"
        style={{
          width: "100%",
          height: "100%",
        }}
        imageStyle={{ borderRadius: 10 }}
      ></ImageBackground>
    </Box>
  );

  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../../assets/grains.png")}
        resizeMode="cover"
        style={{ width, height }}
      >
        <View style={styles.overlay}>
          <SafeAreaView style={{ height }}>
            <ScrollView
              px="6"
              contentContainerStyle={{
                flex: 1,
                paddingBottom: 50,
              }}
            >
              <Header
                onPress={() => navigation.navigate("FarmInitiatives")}
                parentText="Farm Initiatives"
                headingText="Agribooster"
              />

              <Text
                textAlign="center"
                fontWeight="bold"
                mb={5}
                fontFamily="Rajdhani-Bold"
              >
                Key Figures
              </Text>

              <Box
                // width={"5/6"}
                // h="16"
                mb={5}
                margin="auto"
                borderBottomColor="#000"
                borderColor={"#555"}
                borderWidth="1"
                borderRadius={15}
                p={5}
                pb={2}
              >
                <HStack justifyContent={"space-between"}>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp
                        delay={0}
                        end={data["agribooster_1"] / 1000}
                        suffix=",000+"
                      />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Farmers Reached
                    </Text>
                  </View>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp
                        delay={0}
                        end={data["agribooster_2"]}
                        suffix="B"
                      />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Value of Input Financing Accessed
                    </Text>
                  </View>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp
                        delay={0}
                        end={data["agribooster_3"]}
                        suffix="%"
                      />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Baseline Yield Increase
                    </Text>
                  </View>
                </HStack>
              </Box>

              <Text textAlign="center" mb={5} mt={10}>
                The Agribooster Offer is an inclusive end-to-end value chain
                solution that brings together stakeholders that influence the
                conditions necessary for the perennial increase in farmers’
                yield and revenues. It is a farmer-centric model aimed at
                supporting smallholder farmers to get access to quality inputs,
                finance, market linkages, training and extension services
                centred on Good Agricultural Practices (GAP).
              </Text>

              <Text textAlign="center">
                Initiated in 2017, the project has been deployed across 9
                agricultural value-chain in 17 states. In addition to the core
                Agribooster Offer, the project has supported communities with
                greenhouses, Motorcycles, Tablets, boreholes, moisture meters
                and weighing scales.
              </Text>

              <Text textAlign="center" fontWeight={"bold"} mb="5" mt={10}>
                Agribooster Value Addition
              </Text>

              <View alignSelf="center" mb={10}>
                <Text>-- Access to Quality Farm Input</Text>
                <Text>-- Access to Finance</Text>
                <Text>-- Training and Extension Services</Text>
                <Text>-- Market Linkage</Text>
                <Text>-- Stakeholder Engagement</Text>
                <Text>-- Greenhouses</Text>
              </View>

              <View mb={20}>
                {/* <Swiper controlsEnabled={true}> */}
                {[
                  require("../../assets/gallery/agribooster/agribooster1.jpg"),
                  require("../../assets/gallery/agribooster/agribooster2.jpg"),
                  require("../../assets/gallery/agribooster/agribooster3.jpg"),
                  require("../../assets/gallery/agribooster/agribooster4.jpg"),
                  require("../../assets/gallery/agribooster/agribooster5.jpg"),
                  require("../../assets/gallery/agribooster/agribooster6.jpg"),
                  require("../../assets/gallery/agribooster/agribooster7.jpg"),
                ].map((item, index) => renderItem({ item, index }))}
                {/* </Swiper> */}
              </View>

              <View mt={10}></View>
            </ScrollView>
          </SafeAreaView>
        </View>
      </ImageBackground>
    </View>
  );
};

export default Agribooster;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#01655866",
  },
  slideContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  slide1: {
    backgroundColor: "rgba(20,20,200,0.3)",
  },
  slide2: {
    backgroundColor: "rgba(20,200,20,0.3)",
  },
  slide3: {
    backgroundColor: "rgba(200,20,20,0.3)",
  },
});
